export default __webpack_public_path__ + "resources/icons/n240-4f08.webp";